const cotizaciones = state => state.cotizaciones;
const para_orden_compra = state => state.cotizaciones;

export default {
  cotizaciones,
  para_orden_compra,

};